import pagination from '../../utils/pagination'
import {
  FINANCE_PACKAGES_BATCH_DELETE_REQUEST, FINANCE_PACKAGES_BATCH_DELETE_SUCCESS, FINANCE_PACKAGES_BATCH_DELETE_FAILURE,
  FINANCE_PACKAGES_FETCH_MANY_REQUEST, FINANCE_PACKAGES_FETCH_MANY_SUCCESS, FINANCE_PACKAGES_FETCH_MANY_FAILURE,
  FINANCE_PACKAGES_FETCH_REQUEST, FINANCE_PACKAGES_FETCH_SUCCESS, FINANCE_PACKAGES_FETCH_FAILURE,
  FINANCE_PACKAGES_SAVE_REQUEST, FINANCE_PACKAGES_SAVE_SUCCESS, FINANCE_PACKAGES_SAVE_FAILURE,

  EMPTY_FINANCE_PACKAGES,
  CLEAR_ERRORS
} from './types'

export default {
  [FINANCE_PACKAGES_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [FINANCE_PACKAGES_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [FINANCE_PACKAGES_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [FINANCE_PACKAGES_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [FINANCE_PACKAGES_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [FINANCE_PACKAGES_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [FINANCE_PACKAGES_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [FINANCE_PACKAGES_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [FINANCE_PACKAGES_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [FINANCE_PACKAGES_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [FINANCE_PACKAGES_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [FINANCE_PACKAGES_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_FINANCE_PACKAGES] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
